import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Input from "components/Elements/Input";
import {
  getFunction,
  saveFunction,
  clearSavedFunction,
} from "actions/workflows";
import ErrorField from "components/ErrorField";
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { EditorView } from "@codemirror/view";

const AddFunctionModal = NiceModal.create(
  ({ funct = null, funct_id = null }) => {
    console.log("ADD FUNCTION MODAL: ", funct, funct_id);
    const dispatch = useDispatch();
    const { savedFunction, saving } = useSelector((state) => state.workflows);
    const loadedFunct = useSelector((state) => state.workflows.funct);
    console.log("!!! LOADED FUNCT: ", loadedFunct);
    const modal = useModal();

    const hide = (e) => {
      e.stopPropagation();
      dispatch(clearSavedFunction());
      modal.resolve(savedFunction);
      modal.remove();
    };

    const cloneFunction = (funct) => {
      const u = {
        id: "",
        public_id: "",
        name: "",
        description: "",
      };
      Object.keys(funct).forEach((key) => {
        u[key] = funct[key];
      });
      return u;
    };

    const [formErrors, setFormErrors] = useState({});
    const [localFunction, setLocalFunction] = useState(null);
    useEffect(() => {
      if (funct !== null) {
        setLocalFunction(cloneFunction(funct));
      } else if (funct_id !== null) {
        dispatch(getFunction(funct_id));
      }

      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      console.log("LOADED FUNCT: ", loadedFunct);
      if (loadedFunct !== null) {
        setLocalFunction(cloneFunction(loadedFunct));
      }
    }, [loadedFunct]);

    useEffect(() => {
      console.log("SAVED funct: ", savedFunction);
      if (savedFunction) {
        setLocalFunction(cloneFunction(savedFunction));
      }
    }, [savedFunction]);

    const handleChange = ({ target }) => {
      const u = { ...localFunction };
      u[target.name] = target.value;
      setLocalFunction(u);
    };

    const handleCodeChange = (name, code) => {
      const u = { ...localFunction };
      u[name] = code;
      setLocalFunction(u);
    };

    const validateFields = () => {
      setFormErrors({});
      const errors = {};

      console.log("localFunction: ", localFunction);
      const nameValid = localFunction.name && localFunction.name.length > 0;
      errors.name = nameValid ? "" : " is required";

      console.log("errors: ", errors);
      setFormErrors(errors);

      return nameValid;
    };

    const save = () => {
      console.log("save funct: ", localFunction);
      if (validateFields()) {
        dispatch(saveFunction(localFunction));
      }
    };

    return (
      <>
        <div className="w-9/12 force-height-90 rounded-lg shadow-lg force-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative h-full w-full my-6 mx-auto max-w-3xl">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              {/*header*/}
              <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">
                  {localFunction && localFunction.id
                    ? "Edit Function"
                    : "Add Function"}
                </h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={hide}
                >
                  <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className="relative p-6 flex-auto ">
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  <label>ID</label>
                  <Input
                    label="ID"
                    placeholder="ID"
                    name="id"
                    value={
                      localFunction && localFunction.id ? localFunction.id : ""
                    }
                    disabled
                  />
                  <label>Public ID</label>
                  <Input
                    label="Public ID"
                    placeholder="Public ID"
                    name="public_id"
                    value={
                      localFunction && localFunction.public_id
                        ? localFunction.public_id
                        : ""
                    }
                    disabled
                  />
                  <label>
                    Name <ErrorField>{formErrors.name}</ErrorField>
                  </label>
                  <Input
                    label="Name"
                    placeholder="Name"
                    name="name"
                    value={
                      localFunction && localFunction.name
                        ? localFunction.name
                        : ""
                    }
                    onChange={handleChange}
                  />
                  <label>
                    Description{" "}
                    <ErrorField>{formErrors.description}</ErrorField>
                  </label>
                  <Input
                    type="textarea"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={
                      localFunction && localFunction.description
                        ? localFunction.description
                        : ""
                    }
                    onChange={handleChange}
                    style={{ height: "100px" }}
                  />
                  <label>
                    Parameters <ErrorField>{formErrors.parameters}</ErrorField>
                    <span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://platform.openai.com/docs/guides/gpt/function-calling"
                      >
                        (Docs)
                      </a>
                    </span>
                  </label>
                  <CodeMirror
                    extensions={[json(), EditorView.lineWrapping]}
                    label="Parameters"
                    name="parameters"
                    value={
                      localFunction && localFunction.parameters
                        ? localFunction.parameters
                        : ""
                    }
                    onChange={(code) => handleCodeChange("parameters", code)}
                  />
                  <label>
                    Output Parameters (JSON)
                    <ErrorField>{formErrors.output_params}</ErrorField>
                  </label>
                  <CodeMirror
                    extensions={[json(), EditorView.lineWrapping]}
                    label="Output Parameters"
                    name="output_params"
                    value={
                      localFunction && localFunction.output_params
                        ? localFunction.output_params
                        : ""
                    }
                    onChange={(code) => handleCodeChange("output_params", code)}
                    style={{ width: "calc(100vw - 350px)" }}
                  />

                  <label>
                    Code <ErrorField>{formErrors.code}</ErrorField>
                  </label>
                  <CodeMirror
                    extensions={[python(), EditorView.lineWrapping]}
                    label="Code"
                    name="code"
                    value={
                      localFunction && localFunction.code
                        ? localFunction.code
                        : ""
                    }
                    onChange={(code) => handleCodeChange("code", code)}
                  />
                </div>
              </div>

              {/*footer*/}
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                {!saving ? (
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={hide}
                  >
                    Close
                  </button>
                ) : null}
                <button
                  className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={save}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i> Saving...
                    </>
                  ) : (
                    <>Save Changes</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    );
  }
);

export default AddFunctionModal;
